import { WifiMark } from "./WifiMark";

const common = {
    fill: "#141414",
    stroke: "#3f3f46",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
};

export const HoodieSVG = ({ className = "" }) => (
    <svg viewBox="0 0 220 260" className={className} fill="none">
        <path d="M74 58 Q110 6 146 58 L136 68 Q110 46 84 68 Z" {...common} />
        <path d="M70 60 Q110 80 150 60 L176 78 Q196 96 198 150 L182 156 L174 118 L174 232 Q174 246 160 246 L60 246 Q46 246 46 232 L46 118 L38 156 L22 150 Q24 96 44 78 Z" {...common} />
        <path d="M100 76 L94 110 M120 76 L126 110" stroke="#52525b" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M82 178 L138 178 L130 228 L90 228 Z" {...common} />
        <g transform="translate(86,128) scale(0.48)">
            <path d="M 6 66 A 44 44 0 0 1 94 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" className="wifi-arc-3" />
            <path d="M 20 66 A 30 30 0 0 1 80 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" className="wifi-arc-2" />
            <path d="M 34 66 A 16 16 0 0 1 66 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" className="wifi-arc-1" />
            <circle cx="50" cy="68" r="8" fill="#FF3333" className="wifi-dot" />
        </g>
    </svg>
);

export const TeeSVG = ({ className = "" }) => (
    <svg viewBox="0 0 220 220" className={className} fill="none">
        <path d="M70 30 Q110 52 150 30 L182 46 L206 96 L172 112 L164 84 L164 196 Q164 208 152 208 L68 208 Q56 208 56 196 L56 84 L48 112 L14 96 L38 46 Z" {...common} />
        <path d="M76 32 Q110 62 144 32" stroke="#52525b" strokeWidth="2.5" fill="none" />
        <g transform="translate(86,86) scale(0.48)">
            <path d="M 6 66 A 44 44 0 0 1 94 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <path d="M 20 66 A 30 30 0 0 1 80 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <path d="M 34 66 A 16 16 0 0 1 66 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <circle cx="50" cy="68" r="8" fill="#FF3333" />
        </g>
    </svg>
);

export const CrewneckSVG = ({ className = "" }) => (
    <svg viewBox="0 0 220 260" className={className} fill="none">
        <path d="M70 34 Q110 56 150 34 L180 50 Q204 74 208 152 L202 218 L172 212 L168 132 L168 232 Q168 246 154 246 L66 246 Q52 246 52 232 L52 132 L48 212 L18 218 L12 152 Q16 74 40 50 Z" {...common} />
        <path d="M76 36 Q110 64 144 36" stroke="#52525b" strokeWidth="2.5" fill="none" />
        <path d="M52 230 L168 230" stroke="#52525b" strokeWidth="2" />
        <g transform="translate(86,118) scale(0.48)">
            <path d="M 6 66 A 44 44 0 0 1 94 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <path d="M 20 66 A 30 30 0 0 1 80 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <path d="M 34 66 A 16 16 0 0 1 66 66" stroke="#FF3333" strokeWidth="9" strokeLinecap="round" />
            <circle cx="50" cy="68" r="8" fill="#FF3333" />
        </g>
    </svg>
);

export const CapSVG = ({ className = "" }) => (
    <svg viewBox="0 0 220 170" className={className} fill="none">
        <path d="M30 106 Q110 134 190 106 L190 124 Q110 156 30 124 Z" {...common} />
        <path d="M50 106 Q50 34 110 34 Q170 34 170 106 Z" {...common} />
        <path d="M110 36 L110 106 M82 41 Q72 72 70 106 M138 41 Q148 72 150 106" stroke="#52525b" strokeWidth="2" fill="none" />
        <circle cx="110" cy="32" r="5" fill="#3f3f46" />
        <g transform="translate(92,58) scale(0.36)">
            <path d="M 6 66 A 44 44 0 0 1 94 66" stroke="#FF3333" strokeWidth="10" strokeLinecap="round" />
            <path d="M 20 66 A 30 30 0 0 1 80 66" stroke="#FF3333" strokeWidth="10" strokeLinecap="round" />
            <path d="M 34 66 A 16 16 0 0 1 66 66" stroke="#FF3333" strokeWidth="10" strokeLinecap="round" />
            <circle cx="50" cy="68" r="9" fill="#FF3333" />
        </g>
    </svg>
);

export const TexturePanel = ({ className = "" }) => (
    <div className={`relative overflow-hidden ${className}`}>
        <WifiMark className="absolute inset-0 m-auto w-2/3 opacity-20" pulsing={false} color="#3f3f46" />
    </div>
);
